import React from "react";
import ReactApexChart from "react-apexcharts";
import { Box, Typography } from "@mui/material";

export default function PrettyDonut({ data }) {
  const notExec = data.totalCount - (data.passCount + data.failCount);
  const series = [data.passCount, data.failCount, notExec, data?.skippedOver || 0];

  const seriesNames = ["Pass", "Fail", "Not Executed", "Skipped Over"];

  const options = {
    chart: {
      type: "donut",
      height: 350,
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#008000", "#FF4C4C", "#835FF0", "#D6DEF8", "#FFC107"],
    labels: seriesNames,
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
    legend: {
      position: "bottom",
      offsetY: 0,
      horizontalAlign: "center",
      fontSize: "12px",
      itemMargin: {
        horizontal: 5,
        vertical: 2,
      },
      formatter: (seriesName, opts) => {
        const percentage = (
          (opts.w.globals.series[opts.seriesIndex] / data.totalCount) *
          100
        ).toFixed(1);
        return `${seriesName}: ${percentage}%`;
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: "65%",
        },
      },
    },
  };

  return (
    <Box
      sx={{
        bgcolor: "#fff",
        height: "100%",
        borderRadius: "8px",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography
        sx={{
          color: "#232D3D",
          fontSize: "16px",
          fontWeight: 600,
          textAlign: "center",
          marginBottom: "8px",
        }}
      >
        Test Case Results
      </Typography>
      <Box sx={{ flex: 1, minHeight: "300px" }}>
        <ReactApexChart options={options} series={series} type="donut" height="100%" width="100%" />
      </Box>
    </Box>
  );
}
